import {EmailData} from './EmailData'

export type UserCancellationEmailData = EmailData & {
    firstname: string
    canAccessApp: boolean
}
